/*
  Sell page: marks the process card nearest the middle of the row as the active one (the others soften).
  The row itself (swiping, arrows, progress line, counter) is the shared carousel in redeluxe-product-carousel.js.
*/
(function () {
  function setup(root) {
    if (!root || root.getAttribute('data-rx-emphasis-ready')) return;
    var track = root.querySelector('[data-rx-track]');
    var slides = root.querySelectorAll('[data-rx-slide]');
    if (!track || !slides.length) return;
    root.setAttribute('data-rx-emphasis-ready', '1');
    var ticking = false;

    function mark() {
      ticking = false;
      var box = track.getBoundingClientRect();
      var mid = box.left + box.width / 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      for (var j = 0; j < slides.length; j++) slides[j].classList.toggle('is-active', j === best);
    }
    function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(mark); } }

    track.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    mark();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-rx-emphasis]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-rx-emphasis]') : null;
    if (r) setup(r);
  });
})();
